$(document).on 'turbo:load', ->
  itemSelector = '[data-lesson],[data-post]'

  $('[data-search-block][data-total]').each ->
    if $(this).data('total') <= 24
      $(this).find('[data-load-more]').hide()

  $('[data-more-button]').click (e) ->
    e.preventDefault()
    $loadBtn = $(this)
    if $loadBtn.is(":disabled")
      return

    $section = $loadBtn.closest('[data-search-block]')
    nextPage = parseInt($section.data('page')) + 1
    filter = $loadBtn.data('filter')

    searchUrl = 'search?utf8=✓' +
                '&page=' + nextPage +
                '&qs=' + $('#search-param').text() +
                "&filter=" + filter

    $.ajax {
      type: 'get'
      dataType: 'script'
      url: searchUrl
    }

    if $section.data('total') <= (nextPage * 24)
      $section.find('[data-load-more]').hide()

  selectFilter = (filterId) ->
    $filter = $("[data-search-filter=#{filterId}]")
    $("[data-search-filter]").removeClass("current")
    $filter.addClass("current")

    if filterId == "all"
      $("[data-search-block]").show().attr("data-enabled", "true")
      history.pushState(null, null, window.location.href.split('#')[0])
    else
      $("[data-search-block]").hide().attr("data-enabled", "false")
      $("[data-search-block=#{filterId}]").show().attr("data-enabled", "true")
      $("#" + filterId).get(0).scrollIntoView()
      history.pushState(null, null, "#" + filterId);

  $('body').on 'click.searchResults.filter', '[data-search-filter]', (e) ->
    selectFilter $(e.currentTarget).data('search-filter')


  $(document).ready () ->
    filterHashes = {
      "#tededlessons": "ted-ed-lessons",
      "#bestofweb": "teded-best-web",
      "#blogposts": "#blogposts",
    }
    filterId = filterHashes[window.location.hash]
    selectFilter(filterId) if filterId